const COOKIE_NAME = 'portal-session';
const COOKIE_MAX_AGE_DAYS = 1;
const SIDEBAR_PINNED_COOKIE = "portal-sidebar-pinned";
const SIDEBAR_PINNED_MAX_AGE_DAYS = 365;

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

function clearCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
}

export function ensureSessionCookie(): string {
  let id = getCookie(COOKIE_NAME);
  if (!id) {
    id = crypto.randomUUID();
    setCookie(COOKIE_NAME, id, COOKIE_MAX_AGE_DAYS);
  }
  return id;
}

export function clearSessionCookie(): void {
  clearCookie(COOKIE_NAME);
}

export function getSidebarPinnedCookie(): boolean {
  return getCookie(SIDEBAR_PINNED_COOKIE) === "1";
}

export function setSidebarPinnedCookie(isPinned: boolean): void {
  setCookie(SIDEBAR_PINNED_COOKIE, isPinned ? "1" : "0", SIDEBAR_PINNED_MAX_AGE_DAYS);
}
